import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleSignIn from './GoogleSignIn';
import PrimaryButton from './PrimaryButton';
import styles from './FramerNavBar.module.css';

function FramerNavBar({ onGoogleSuccess, onGoogleError }) {
  const navigate = useNavigate();

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`${styles.navbar} open-sans-navbar`}>
      <div className={styles.navContainer}>
        <div className={styles.navContent}>
          <div className={styles.logoEnclosure}>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className={styles.logoLink}
            >
              <img
                src="https://framerusercontent.com/images/8zeV89LOlB8u6tnebXEoCrGl598.png"
                alt="Kumu Connect Logo"
                className={styles.logo}
              />
            </a>
          </div>
          <div className={styles.links}>
            <button
              className={`${styles.navLink} ${styles.navLinkActive}`}
              onClick={() => handleScrollTo('solution')}
            >
              Solution
            </button>
            <button
              className={styles.navLink}
              onClick={() => handleScrollTo('about')}
            >
              About Us
            </button>
            <button
              className={styles.navLink}
              onClick={() => handleScrollTo('faq')}
            >
              FAQs
            </button>
            <div className={styles.contactEnclosure}>
              <button
                className={`${styles.navLink} ${styles.navLinkButton}`}
                onClick={() => handleScrollTo('contact')}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
        <div id="top-nav-signin" className={styles.signInTopRight}>
          <div className={styles.signInButtonShell}>
            <PrimaryButton className={styles.signInVisualButton} ariaLabel="Sign in with Google">
              Sign In
            </PrimaryButton>
            <GoogleSignIn
              onSuccess={onGoogleSuccess}
              onError={onGoogleError}
              size="large"
              text="signin_with"
              width={128}
              className={styles.signInGoogleOverlay}
              containerStyle={{ minHeight: '42px', width: '100%' }}
            />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default FramerNavBar;
